import { jsonProperty, Serializable } from 'ts-serializable';

import { DealerCommentItemDto } from './DealerCommentItemDto';

export class SurveyCommentsDto extends Serializable {
  @jsonProperty(String, null) workorderId: string | null = null;
  @jsonProperty([DealerCommentItemDto], null) data: DealerCommentItemDto[] | null = null;
}
